<script>
/**
 * @overview 场景管理 - 列表单项
 *
 * @author huojinzhao
 */

export default {
  name: "ThemeItem",

  props: {
    data: {
      type: Object,
      required: true,
    },
    // 复制权限
    isFuzhiPermissions: {
      type: Boolean,
      default: false,
    },
    // 移动权限
    isMovePermissions: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <AppMasker
    :is-fuzhi-permissions="isFuzhiPermissions"
    :is-move-permissions="isMovePermissions"
    types="edit,fuzhi,move,delete"
    class="theme-item"
    width="240px"
    radius
    @edit="$emit('update', data)"
    @delete="$emit('delete', data)"
    @fuzhi="$emit('fuzhi', data)"
    @move="$emit('move', data)"
  >
    <span
      :style="{
        'background-image': `url(${data.cover})`
      }"
      class="
        layout-backdrop
        theme-item__cover
      "
    >
      <span v-if="!data.cover">没有主题封面</span>
    </span>

    <ol class="module-list-item-label">
      <li class="layout-ellipsis">{{ data.name }}</li>
      <li class="layout-ellipsis">{{ data.created_at }}</li>
    </ol>
  </AppMasker>
</template>

<style lang="postcss">
.theme-item {
  display: flex;
  flex-direction: column;
  position: relative;
}

.theme-item__cover {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--font-color-secondary);
  width: 100%;
  font-size: 1.5em;
}

.theme-item .module-list-item-label {
  margin-top: auto
}
</style>
